import axios from 'axios'
import { endpointAppendProducebook } from './enpoints'

const eventSetProducebookSheet = () => {
  const endpoint = endpointAppendProducebook.cloud

  const appendRow = async (payload: any) => {
    const fullEndpoint = endpoint
    const { data } = await axios.post(fullEndpoint, payload)
    return data
  }
  return {
    appendRow
  }
}

export default eventSetProducebookSheet